import type {RiaQueryFilter} from '../../types'

import type {ReportListParams} from './useReports'

export const riskSurveyQueryKeys = {
  reports: {
    all: ['risk-survey-reports'] as const,
    lists: () => [...riskSurveyQueryKeys.reports.all, 'lists'] as const,
    list: (params: ReportListParams) =>
      [
        ...riskSurveyQueryKeys.reports.lists(),
        'paginated',
        params.upmId,
        params.page,
        params.pageSize,
        params.includeArchived,
        params.sortBy,
        params.sortDir
      ] as const,
    allList: (params: Omit<ReportListParams, 'page' | 'pageSize'>) =>
      [
        ...riskSurveyQueryKeys.reports.lists(),
        'all',
        params.upmId,
        params.includeArchived,
        params.sortBy,
        params.sortDir
      ] as const,
    detail: (reportId: string) => [...riskSurveyQueryKeys.reports.all, 'detail', reportId] as const,
    auditLog: (reportId: string) =>
      [...riskSurveyQueryKeys.reports.all, 'audit-log', reportId] as const,
    links: (reportId: string) => [...riskSurveyQueryKeys.reports.all, 'links', reportId] as const
  },
  rias: {
    all: ['risk-survey-rias'] as const,
    lists: () => [...riskSurveyQueryKeys.rias.all, 'lists'] as const,
    list: (filter: RiaQueryFilter) => [...riskSurveyQueryKeys.rias.lists(), filter] as const,
    detail: (riaId: string) => [...riskSurveyQueryKeys.rias.all, 'detail', riaId] as const,
    comments: (riaId: string) => [...riskSurveyQueryKeys.rias.all, 'comments', riaId] as const,
    auditLog: (riaId: string) => [...riskSurveyQueryKeys.rias.all, 'audit-log', riaId] as const,
    detailsAuditLog: (riaId: string) =>
      [...riskSurveyQueryKeys.rias.all, 'details-audit-log', riaId] as const
  },
  users: {
    all: ['risk-survey-users'] as const,
    suggestions: (upmId: string, namePattern: string) =>
      [...riskSurveyQueryKeys.users.all, 'suggestions', upmId, namePattern] as const
  }
} as const
